import { Galerie } from '@components/galerie/models';
import { galerieTextMock, imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const galerie2it4iMock: Block<Galerie> = {
  type: 'galerie',
  data: {
    layout: '2it4i',
    title: {
      text: `Une cuisine stylée et bien pensée`,
      as: 'h2',
    },
    hideLastItem: false,
    items: [
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        text: galerieTextMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
      {
        image: imageMock,
      },
    ],
  },
};
